/* eslint-disable max-len */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form, Row, Col, Button, Container } from 'react-bootstrap';
import MultiSignalsFormControl from '../../components/MultiSignalsFormControl/MultiSignalsFormControl';
import { activationRequest } from '../../store/account/userActions';
import './Activation.scss';
import { NavLink } from 'react-router-dom';
import { 
  Shield, 
  Key, 
  CheckCircle, 
  UserPlus, 
  Sparkles,
  ArrowRight,
  Lock
} from 'lucide-react';

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

function Activation({ ...props }) {
  const { history, activation } = props;
  const [state, setState] = useState({
    data: {
      activationCode: '',
      activationToken: params.token,
    },
    errors: {},
  });

  const validate = () => {
    const { data } = state;
    const errors = {};
    if (data.activationCode === '') errors.activationCode = 'Activation Code cannot be blank.';

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { data } = state;
    const errors = validate();

    const payload = {
      activationCode: data.activationCode,
      activationToken: data.activationToken,
      history: history,
    };

    if (Object.keys(errors).length === 0) {
      activation(payload);

      setState({
        data: {
          activationCode: '',
          activationToken: params.token,
        },
        errors: {},
      });
    } else {
      setState({
        errors,
      });
    }
  };

  const handleChange = (e) => {
    setState({
      data: {
        ...state.data,
        activationCode: e.target.value,
      },
      errors: {
        ...state.errors,
        activationCode: '',
      },
    });
  };

  const { data, errors } = state;

  return (
    <div className="modern-activation-page">
      <Container fluid className="activation-container">
        <Row className="min-vh-100 g-0">
          {/* Left Side - Welcome Panel */}
          <Col lg={6} className="welcome-panel d-none d-lg-flex">
            <div className="welcome-content">
              <div className="welcome-header">
                <div className="brand-icon">
                  <Sparkles size={48} />
                </div>
                <h1 className="welcome-title">
                  Welcome to the exciting world of <span className="brand-name">MultiSignals</span>
                </h1>
                <p className="welcome-subtitle">
                  Step into the dynamic sphere of advanced trading, where each exploration promises 
                  fascinating discoveries in the world of digital currency and blockchain technology.
                </p>
              </div>

              <div className="feature-list">
                <div className="feature-item">
                  <div className="feature-icon">
                    <Shield size={24} />
                  </div>
                  <div className="feature-content">
                    <h4>Secure Platform</h4>
                    <p>Bank-level security with advanced encryption</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">
                    <Key size={24} />
                  </div>
                  <div className="feature-content">
                    <h4>API Integration</h4>
                    <p>Connect with major exchanges seamlessly</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-icon">
                    <CheckCircle size={24} />
                  </div>
                  <div className="feature-content">
                    <h4>Proven Results</h4>
                    <p>Track record of successful trading strategies</p>
                  </div>
                </div>
              </div>

              {/* Decorative Elements */}
              <div className="decorative-elements">
                <div className="floating-shape shape-1"></div>
                <div className="floating-shape shape-2"></div>
                <div className="floating-shape shape-3"></div>
              </div>
            </div>
          </Col>

          {/* Right Side - Activation Form */}
          <Col lg={6} className="form-panel">
            <div className="form-container">
              <div className="form-header">
                <div className="activation-icon">
                  <Lock size={32} />
                </div>
                <h2 className="form-title">Activate Your Account</h2>
                <p className="form-subtitle">
                  Enter the activation code sent to your email to complete your registration
                </p>
              </div>

              <div className="activation-form">
                <Form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <MultiSignalsFormControl
                      label="Activation Code"
                      type="password"
                      value={data.activationCode}
                      handleChange={handleChange}
                      error={errors.activationCode}
                      placeholder="Enter your activation code"
                    />
                  </div>

                  <Button className="modern-submit-btn" type="submit">
                    <span>Activate Account</span>
                    <ArrowRight size={18} />
                  </Button>
                </Form>

                <div className="form-footer">
                  <div className="signup-link-container">
                    <span className="signup-text">Don't have an account yet?</span>
                    <NavLink className="signup-link" to="/signup">
                      <UserPlus size={16} />
                      Sign Up
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    activation: (creds) => {
      dispatch(activationRequest(creds));
    },
  };
};

export default connect(null, mapDispatchToProps)(Activation);